const teams = [
  {
    name: 'Los Angeles Lakers',
    image: 'Lakers.png',
    description:
      'The Los Angeles Lakers, one of the most iconic NBA teams with a rich history of success.',
    history: [
      { year: '1980', event: 'Won their 7th NBA Championship' },
      { year: '1984', event: 'Reached the NBA Finals' },
      { year: '2000', event: 'Started the three-peat era' },
      { year: '2010', event: 'Won their 16th NBA Championship' },
      { year: '2020', event: 'Won the NBA Championship' },
    ],
  },
  {
    name: 'Chicago Bulls',
    image: 'Bulls.png',
    description:
      'The Chicago Bulls, home to basketball legend Michael Jordan and a legacy of greatness.',
    history: [
      { year: '1991', event: 'Won their first NBA Championship' },
      { year: '1993', event: 'Completed the first three-peat' },
      { year: '1996', event: '72-win season and NBA title' },
      { year: '1998', event: 'Completed the second three-peat' },
      { year: '2010', event: 'Reached the Eastern Conference Finals' },
    ],
  },
  {
    name: 'Toronto Raptors',
    image: 'Raptors.png',
    description:
      'The Canadian professional basketball team Known for their championship win in 2019.',
    history: [
      { year: '2000', event: 'First playoff appearance' },
      { year: '2016', event: 'Eastern Conference Finals' },
      { year: '2018', event: 'Top seed in the Eastern Conference' },
      { year: '2019', event: 'Won their first NBA Championship' },
      { year: '2020', event: 'Reached the second round of playoffs' },
    ],
  },
  {
    name: 'Denver Nuggets',
    image: 'Nuggets.png',
    description:
      'Named after the Colorado Gold Rush, Best known for current star Nikola Jokić.',
    history: [
      { year: '1976', event: 'Joined the NBA from the ABA' },
      {
        year: '1985',
        event: 'Reached the Western Conference Finals for the first time',
      },
      {
        year: '2009',
        event: 'Advanced to the Western Conference Finals with Carmelo Anthony',
      },
      {
        year: '2023',
        event: 'Won their first NBA Championship led by Nikola Jokić',
      },
    ],
  },
];

export default teams;
